<template>
  <div class="goodsDetailsPage">
    <!-- header start -->
    <van-nav-bar
      title="产品详情"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div v-if="dataModel!=null">
      <section class="swiper-area">
        <van-swipe :autoplay="5000" @change="onChange">
          <van-swipe-item v-for="(banner,index) in dataModel.DistributionProductApiModel.DistributionProductPhotosList" :key="index">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="banner.ImagePath"
              @click="preview(index)"
            />
          </van-swipe-item>
          <template #indicator>
            <div class="custom-indicator">
              <i v-text=" currentIndex + 1 "></i> / <i>{{dataModel.DistributionProductApiModel.DistributionProductPhotosList.length}}</i>
            </div>
          </template>
        </van-swipe>
      </section>
      <section class="pro-head">
        <div class="price">￥<span class="money">{{dataModel.DistributionProductApiModel.Price}}</span></div>
        <h2 class="title">{{dataModel.DistributionProductApiModel.DProductName}}</h2>
      </section>
      <section class="pro-body">
        <div class="title">产品详情</div>
        <div v-html="dataModel.DistributionProductApiModel.Content" class="tbody"></div>
      </section>
      <section class="details__bottom">
        <van-button block color="orange" size="large" :to="{path:'/MemberBuy',query:{
          id:dataModel.DistributionProductApiModel.DistributionLevelId,
          pid:dataModel.DistributionProductApiModel.DProductId
        }}">开通会员</van-button>
      </section>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
  data() {
    return {
      currentIndex: 0,
      bannerPicArray:[
        // {imageUrl:'https://resources.ninghao.org/images/candy-shop.jpg'},
        // {imageUrl:'https://resources.ninghao.org/images/childhood-in-a-picture.jpg'},
        // {imageUrl:'https://resources.ninghao.org/images/contained.jpg'},
      ],
      dataModel:null,
      isFirstEnter:false,
    };
  },
  components: {},
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2 !important");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init(id){
      var that=this;
      var params = {
        type: "GetDistributionProductById",
        Id:id
      };
      that.$store.dispatch(params).then(res=>{
          this.dataModel=res;
          that.bannerPicArray=[];
          this.dataModel.DistributionProductApiModel.DistributionProductPhotosList.forEach(element => {
              that.bannerPicArray.push(element.BreviaryImgPath);
          });

      },error=>{


      })

    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onChange(index) {
      this.currentIndex = index;
    },
    preview(index) {
      ImagePreview({
        images:this.bannerPicArray,
        startPosition: index
      });
      
    },
  },
  beforeRouteEnter(to, from, next) {
    console.log(from);
    if(from.name=="MemberBuy")
    {
        to.meta.isBack=true;
    }
    next();
  },
  activated(){
    var _query = this.$route.query;
    console.log("activated");
    console.log(this.$route.meta.isBack+"___"+this.isFirstEnter);
      if(!this.$route.meta.isBack || this.isFirstEnter){
       this.init(_query.id);
     }
     this.$route.meta.isBack=false;
     this.isFirstEnter=false;
  },
  created(){
      this.isFirstEnter=true;


  }
};
</script>

<style scoped>
.swiper-area{
  height: 360px;
}
.van-swipe{
  width: 100%;
  height: 100%;
}
.custom-indicator {
  position: absolute;
  right: 5px;
  bottom: 5px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  color: #fff;
}
.goodsDetailsPage{
  padding-bottom: 50px;
}
.details__bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  background-color: #fff;
}
.details__bottom .van-button{
  height: 50px;
  line-height: 50px;
}
.pro-head{
  background-color: #fff;
  padding:10px;
}
.pro-head .price{
  font-size: 14px;
  color: crimson;
  margin-bottom: 2px;
}
.pro-head .price .money{
  font-size: 21px;
}
.pro-head .title{
  font-size: 15px;
  font-weight: normal;
  line-height: 1.5;
}
.pro-body{
  margin-top: 8px;
  margin-bottom: 8px;
  background-color: #fff;
}
.pro-body .title{
  font-size: 14px;
  color: #666;
  padding: 12px 10px;
}
</style>
